import React from "react";
import Tags from "../components/Meta/Tags";
import Banner from "../components/Banner";
import Content from "../components/Plans/Content";
import PlansImage from "../assets/img/planes_new.jpeg";

const NuestrosPlanes = () => (
  <>
  <Tags 
    title="Elegí tu plan de medicina prepaga" 
    description="Encontrá tu plan de medicina prepaga con atención confiable, centros médicos propios en CABA y cobertura de salud para tus necesidades y la de tu familia." 
    keywords="Salud, A-10 plus, c-60 plus, Plan para jubilados, Plan familiar, Economico, Sin limite de edad, Preexistencia, Emergencias domiciliarias," 
    canonical="/nuestros-planes" />
    <div className="page-nuestros-planes">
    <Banner
      title="NUESTROS PLANES"
      image={PlansImage}
      subtitle="Elegí tu plan de medicina prepaga en Alta Salud."
      height="planes"
      size="8"
    />
    </div>
    <Content />
  </>
);

export default NuestrosPlanes;
